export const patriotic = [
  {
    number: 'P105',
    hasModel: false
  },
  {
    number: 'P106',
    hasModel: false
  },
  {
    number: 'P107',
    hasModel: false
  },
  {
    number: 'P108',
    hasModel: false
  },
  {
    number: 'P109',
    hasModel: false
  },
  {
    number: 'P110',
    hasModel: false
  },
  {
    number: 'P111',
    hasModel: false
  },
  {
    number: 'P112',
    hasModel: false
  },
  {
    number: 'P113',
    hasModel: false
  },
  {
    number: 'P114',
    hasModel: false
  },
  {
    number: 'P115',
    hasModel: false
  },
  {
    number: 'P116',
    hasModel: false
  },
  {
    number: 'P117',
    hasModel: false
  },
  {
    number: 'P118',
    hasModel: false
  },
  {
    number: 'P119',
    hasModel: false
  },
  {
    number: 'P120',
    hasModel: false
  },
  {
    number: 'P121',
    hasModel: false
  },
  {
    number: 'P122',
    hasModel: false
  },
  {
    number: 'P123',
    hasModel: false
  },
  {
    number: 'P124',
    hasModel: false
  },
  {
    number: 'P125',
    hasModel: false
  },
  {
    number: 'P126',
    hasModel: false
  },
  {
    number: 'P127',
    hasModel: false
  },
  {
    number: 'P128',
    hasModel: false
  },
  {
    number: 'P129',
    hasModel: false
  },
  {
    number: 'P130',
    hasModel: false
  },
  {
    number: 'P131',
    hasModel: false
  },
  {
    number: 'P132',
    hasModel: false
  },
  {
    number: 'P133',
    hasModel: false
  },
  {
    number: 'P134',
    hasModel: false
  },
  {
    number: 'P135',
    hasModel: false
  },
  {
    number: 'P136',
    hasModel: false
  },
  {
    number: 'P137',
    hasModel: false
  },
  {
    number: 'P138',
    hasModel: false
  },
  {
    number: 'P139',
    hasModel: false
  },
  {
    number: 'P140',
    hasModel: false
  },

]